<template>
  <div>
    <b-modal
      ref="modalUnsavedChanges"
      :title="$t('Webportal.Dialog.UnsavedChanges.Title')"
      :ok-title="$t('Webportal.Dialog.UnsavedChanges.Ok')"
      :cancel-title="$t('Webportal.Dialog.UnsavedChanges.Cancel')"
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
    >
      {{ $t("Webportal.Dialog.UnsavedChanges.Text") }}
    </b-modal>

    <b-modal
      header-bg-variant="danger"
      ref="modalSaveError"
      :title="$t('Webportal.Dialog.SaveError.Title')"
      :ok-title="$t('Webportal.Dialog.SaveError.Ok')"
      ok-only>
      {{ $t("Webportal.Dialog.SaveError.Text") }}
    </b-modal>

    <div class="animated fadeIn">
      <div class="container">
        <b-nav tabs>
          <b-nav-item to="/administration/clientsettings">
            <font-awesome-icon :icon="['fas', 'building']" fixed-width />
            {{ $t("Webportal.Administration.ClientSettings") }}
          </b-nav-item>
          <b-nav-item to="/administration/surveysettings">
            <font-awesome-icon :icon="['fas', 'file']" fixed-width />
            {{ $t("Webportal.Administration.SurveySettings") }}
          </b-nav-item>
          <b-nav-item to="/administration/generalsettings">
            <font-awesome-icon :icon="['fas', 'cog']" fixed-width />
            {{ $t("Webportal.Administration.GeneralSettings") }}
          </b-nav-item>
          <b-nav-item v-if="hasDashboard()" to="/administration/cxsettings">
            <font-awesome-icon :icon="['fas', 'cogs']" fixed-width />
            &nbsp;{{ $t("Webportal.CXReporting") }}
          </b-nav-item>
          <b-nav-item v-if="hasDashboard()" to="/administration/cxclientsettings">
            <font-awesome-icon :icon="['fas', 'cogs']" fixed-width />
            &nbsp;{{ $t("Webportal.CXReporting") }} - {{ $t("Webportal.Administration.ClientSettings") }}
          </b-nav-item>
          <b-nav-item v-if="hasDashboard()" to="/administration/cxfirstaidsettings">
            <font-awesome-icon :icon="['fas', 'cogs']" fixed-width />
            &nbsp;{{ $t("Webportal.CXReporting") }} - {{ $t("Webportal.CX.FirstAid") }}
          </b-nav-item>
        </b-nav>
        <div class="tab-content mb-3" id="settings-pane">
          <div class="tab-pane fade show active" role="tabpanel">
            <keep-alive>
              <router-view
                @unsavedChanges="componentUnsavedChanges"
                @saveError="componentSaveError"
              />
            </keep-alive>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppConfig from "@/mixins/AppConfig-APP_TARGET";
export default {
  name: "Administration",
  mixins: [AppConfig],
  methods: {
    componentUnsavedChanges(isFormDirty, callback) {
      if (isFormDirty) {
        let dialog = this.$refs.modalUnsavedChanges;

        dialog.$off();
        dialog.$on("ok", (_) => callback());
        dialog.$on("cancel", (_) => callback(false));
        dialog.show();
      } else callback();
    },
    componentSaveError(callback) {
      let dialog = this.$refs.modalSaveError;

      dialog.$off();
      dialog.$on("ok", (_) => callback());
      dialog.$on("cancel", (_) => callback(false));
      dialog.show();
    },
  },
};
</script>